module.exports = __webpack_public_path__ + "img/icon_features_pause1_hover.f853fb52.svg";